<template>
  <div class="login-body">
    <Toast/>
    <Dialog :header="$t('login.changepassword')" :visible="showChangeDialog" :style="{'max-width': '30em'}"
            :closable="false" :modal="true" :draggable="false">
      <div class="grid change-password-box">
        <div class="col-12">
        <span class="p-float-label">
                      <Password autocomplete="new-password" toggleMask v-model="newPassword"/>
                      <label>{{ $t('login.newpassword') }}</label>
        </span>
        </div>
        <div class="col-12">
        <span class="p-float-label">
                      <Password autocomplete="new-password" toggleMask v-model="confirmNewPassword"/>
                      <label>{{ $t('login.confirmnewpassword') }}</label>
        </span>
        </div>
      </div>
      <template #footer>
        <Button :disabled="loading" icon="pi pi-check" :label="$t('common.buttons.save')" @click="changePassword"/>
      </template>
    </Dialog>

    <div class="box">
      <div class="grid">
        <div class="col-5">
          <img class="animation" src="assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB"
               style="margin-bottom: 2em; height: 5em; float: right"/>
        </div>
        <div class="col">
          <h2 class="sso-text">: SSO</h2>
          <h2 class="auth-text">-AUTHENTICATION</h2>
        </div>
      </div>
      <div class="grid center">
        <div class="point animation-point"></div>
        <div class="point animation-point"></div>
        <div class="point animation-point"></div>
        <div class="point animation-point"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SsoService from "@/service/SsoService";
import {useUserStore} from "@/store/userStore";
import {useLoadingStore} from "@/store/loadingStore";
import {useEndpointStore} from "@/store/endpointStore";
import gsap from "gsap";
import LoginService from "@/service/LoginService";
import {useApplicationStore} from "@/store/applicationStore";
import IamBackendService from "../service/IamBackendService";

export default {
  beforeCreate() {
    this.ssoService = new SsoService();
    this.loginService = new LoginService();
    this.iamBackendService = new IamBackendService();
    this.userStore = useUserStore();
    this.loadingStore = useLoadingStore();
    this.endpointStore = useEndpointStore();
    this.applicationStore = useApplicationStore();
  },
  beforeMount() {
    this.$endpoints.refreshEndpoints()
  },
  mounted() {
    this.showSsoLoading = true
    this.animation();
    this.sendCoockie();
  },
  data() {
    return {
      showChangeDialog: false,
      username: null,
      password: null,
      newPassword: null,
      confirmNewPassword: null,
      showSsoLoading: false
    }
  },
  computed: {
    loading() {
      return this.loadingStore.loading
    }
  },
  methods: {
    sendCoockie() {
      this.iamBackendService.sendCoockie().then(responseAuthentication => {
        this.userStore.setUser({token: responseAuthentication.token.jwt, refresh: responseAuthentication.token.refresh})
        this.$endpoints.userInfo(responseAuthentication.token, this.$router, this)
      }).catch(() => {
        this.loadingStore.resetLoading();
        this.$toast.add({
          severity: "error",
          summary: this.$t("toasts.authenticationError.summary"),
          detail: this.$t("toasts.authenticationError.detail"),
          life: 4000
        });
      });
    },
    animation() {
      this.tl = gsap.timeline({repeat: -1});
      this.tl.from('.animation-point', {
        duration: .6,
        opacity: 0,
        scale: 0,
        ease: 'power1',
        stagger: {
          each: 0.1,
          from: 'left'
        }
      })
      this.tl.to('.animation-point', {
        duration: .6,
        scale: 0,
        opacity: 0,
        ease: 'power1',
        stagger: {
          each: 0.1,
          from: 'left'
        }
      }, .6)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "public/assets/sass/layout/mixins.scss";
@import "public/assets/sass/overrides/layout_variables";

.button-landing {
  margin-top: 1em;
  width: 80%;
  height: 3em;
  max-width: 40em;
}

.login-body {
  padding: 0;
  margin: 0;
  min-height: 100vh;

  .login-panel {
    display: none;
  }

  .login-content {
    position: fixed;
    padding: 80px 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    text-align: center;

    img {
      display: inline-block;
      margin-bottom: 24px;
      width: 200px;
    }

    h1 {
      font-size: 28px;
      font-weight: 500;
      margin: 14px 0;
      color: black;

      span {
        color: gray;
      }
    }

    p {
      font-size: 17px;
      color: gray;
      margin: 0 0 32px 0;
    }

    .login-input-wrapper {
      position: relative;
      width: 300px;
      margin-bottom: 24px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      input {
        width: 100%;
        padding-right: 16px;
      }

      i {
        position: absolute;
        color: gray;
        font-size: 16px;
        top: 50%;
        right: .429em;
        margin-top: -8px;
      }
    }

    button {
      min-width: 150px;
    }
  }
}


@media screen and (min-width: 768px) {
  .login-body {
    background: url("../../public/assets/layout/images/pages/landing_page_bg.jpg");
    background-size: cover;

    .login-panel {
      padding: 80px;
      display: block;
      position: fixed;
      background-color: #ffffff;
      height: 200%;
      width: 100%;
      left: -50%;
      top: -50%;
      border-radius: 50%;
    }

    .login-content {
      text-align: left;
      position: fixed;
      padding: 80px 0 0 80px;

      .login-input-wrapper {
        width: 300px;
        margin-left: 0;
        margin-right: 0;
        text-align: left;
      }
    }
  }
}

.box {
  background-color: white;
  margin: auto;
  width: 40em;
  opacity: 90%;
  text-align: center;
  padding: 1em;
  border-radius: .5em;
  padding-bottom: 2em;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.point {
  height: 2em;
  width: 2em;
  border-radius: 50%;
  margin-left: 1em;
  margin-right: 1em;
  background: $blue3;
  margin-top: -1em;
}

.sso-text {
  float: left;
  margin-top: .7em;
  color: $green1;
  margin-left: -.9em;
}

.auth-text {
  float: left;
  margin-top: .7em;
  color: $blue2;
}
</style>
